var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedVerticleStrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16.02 67.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Garnet);}.cls-15,.cls-2{opacity:0.35;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#Carrot);}.cls-19,.cls-20,.cls-21,.cls-29,.cls-30,.cls-6,.cls-7,.cls-8{opacity:0.59;}.cls-6{fill:url(#Carrot-2);}.cls-7{fill:url(#Carrot-3);}.cls-8{fill:url(#Carrot-4);}.cls-9{fill:#353739;}.cls-10{fill:url(#linear-gradient-4);}.cls-11{fill:url(#linear-gradient-5);}.cls-12{fill:url(#linear-gradient-6);}.cls-13,.cls-25,.cls-32{opacity:0.5;}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:url(#Garnet-2);}.cls-15{fill:url(#linear-gradient-8);}.cls-16{fill:url(#linear-gradient-9);}.cls-17{fill:url(#linear-gradient-10);}.cls-18{fill:url(#Carrot-5);}.cls-19{fill:url(#Carrot-6);}.cls-20{fill:url(#Carrot-7);}.cls-21{fill:url(#Carrot-8);}.cls-22{fill:url(#linear-gradient-11);}.cls-23{fill:url(#linear-gradient-12);}.cls-24{fill:url(#linear-gradient-13);}.cls-25{fill:url(#linear-gradient-14);}.cls-26{fill:url(#Garnet-3);}.cls-27{fill:url(#linear-gradient-15);}.cls-28{fill:url(#Carrot-9);}.cls-29{fill:url(#Carrot-10);}.cls-30{fill:url(#Carrot-11);}.cls-31{fill:#b55e47;}.cls-32{fill:url(#linear-gradient-16);}.cls-33{fill:url(#linear-gradient-17);}.cls-34{fill:url(#linear-gradient-18);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Garnet",
    x1: -1186.94,
    y1: 764.44,
    x2: -1170.93,
    y2: 764.44,
    gradientTransform: "matrix(1, 0, 0, -1, 1186.94, 821.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#961c1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b0605d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#9a4c4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#7b3031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#681f21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61191b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1171.53,
    y1: 777.49,
    x2: -1171.53,
    y2: 755.04,
    gradientTransform: "matrix(1, 0, 0, -1, 1186.94, 821.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fdcfb0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdcfaf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1186.37,
    y1: 769.01,
    x2: -1171.15,
    y2: 753.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1186.27,
    y1: 779.26,
    x2: -1186.27,
    y2: 769.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot",
    x1: 1917.42,
    y1: -2341.16,
    x2: 1932.49,
    y2: -2341.16,
    gradientTransform: "translate(2349.14 1978.73) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#c2671d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d37a35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#d77e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#e7863a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#f28b3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#f68d3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f68e3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f59143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f49750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f39f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f2a56e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f49a56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f68d3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ed8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ee8b3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#ef944d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f2a269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f2a56e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#f9bd85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdca92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-2",
    x1: -1184.34,
    y1: 772.68,
    x2: -1183.31,
    y2: 772.68,
    gradientTransform: "matrix(1, 0, 0, -1, 1186.94, 821.42)",
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-3",
    x1: 1603.89,
    y1: -2472.21,
    x2: 1604.69,
    y2: -2472.21,
    gradientTransform: "matrix(-0.69, 0.72, 0.72, 0.69, 2904.39, 601.71)",
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-4",
    x1: -1174.69,
    y1: 767.63,
    x2: -1173.5,
    y2: 767.63,
    gradientTransform: "matrix(1, 0, 0, -1, 1186.94, 821.42)",
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -120.39,
    y1: 2105.86,
    x2: -120.39,
    y2: 2104.52,
    gradientTransform: "translate(2116.77 172.87) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1938.09,
    y1: -2343.18,
    x2: 1938.09,
    y2: -2344.51,
    gradientTransform: "translate(2348.21 1986.51) rotate(-90)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1177.97,
    y1: 716.79,
    x2: -1179.09,
    y2: 715.67,
    gradientTransform: "matrix(1, 0, 0, -1, 1186.94, 770.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1922.98,
    y1: -2335.76,
    x2: 1922.98,
    y2: -2334.36,
    gradientTransform: "translate(2349.14 1978.73) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdcfaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdcfb0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Garnet-2",
    x1: -1186.88,
    y1: -1260.21,
    x2: -1170.87,
    y2: -1260.21,
    gradientTransform: "translate(1186.88 1270.93)",
    xlinkHref: "#Garnet"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1171.46,
    y1: -1246.59,
    x2: -1171.46,
    y2: -1268.03,
    gradientTransform: "translate(1186.88 1270.93)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -1186.31,
    y1: -1255.64,
    x2: -1171.09,
    y2: -1270.86,
    gradientTransform: "translate(1186.88 1270.93)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -1186.2,
    y1: -1245.06,
    x2: -1186.2,
    y2: -1255.56,
    gradientTransform: "translate(1186.88 1270.93)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-5",
    x1: 1957.3,
    y1: -2341.17,
    x2: 1972.37,
    y2: -2341.17,
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-6",
    x1: -1184.33,
    y1: -1251.98,
    x2: -1183.14,
    y2: -1251.98,
    gradientTransform: "translate(1186.88 1270.93)",
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-7",
    x1: 3068.77,
    y1: -1074.67,
    x2: 3069.58,
    y2: -1074.67,
    gradientTransform: "matrix(-0.69, -0.72, 0.72, -0.69, 2904.4, 1490.56)",
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-8",
    x1: -1174.6,
    y1: -1257.02,
    x2: -1173.44,
    y2: -1257.02,
    gradientTransform: "translate(1186.88 1270.93)",
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1853.15,
    y1: 2105.94,
    x2: 1853.15,
    y2: 2104.56,
    gradientTransform: "matrix(0, -1, -1, 0, 2116.8, 1868.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -35.59,
    y1: -2343.08,
    x2: -35.59,
    y2: -2344.41,
    gradientTransform: "matrix(0, 1, 1, 0, 2348.17, 54.83)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -1177.77,
    y1: -1256.78,
    x2: -1178.99,
    y2: -1258,
    gradientTransform: "translate(1186.88 1270.93)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1437.3,
    y1: -2335.72,
    x2: 1437.3,
    y2: -2334.32,
    gradientTransform: "matrix(0, 1, 1, 0, 2349.13, -1425.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Garnet-3",
    x1: 1944.81,
    y1: -2349.15,
    x2: 1944.81,
    y2: -2333.14,
    gradientTransform: "translate(2349.14 1978.73) rotate(-90)",
    xlinkHref: "#Garnet"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1944.81,
    y1: -2346.63,
    x2: 1944.81,
    y2: -2347.81,
    gradientTransform: "translate(2349.14 1978.73) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e332f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c2826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-9",
    x1: 1957.47,
    y1: -2341.16,
    x2: 1932.12,
    y2: -2341.16,
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-10",
    x1: -1174.67,
    y1: 787.46,
    x2: -1173.49,
    y2: 787.46,
    gradientTransform: "matrix(1, 0, 0, -1, 1186.94, 821.42)",
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-11",
    x1: -1184.38,
    y1: 787.46,
    x2: -1183.27,
    y2: 787.46,
    gradientTransform: "matrix(1, 0, 0, -1, 1186.94, 821.42)",
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1944.82,
    y1: -2335.76,
    x2: 1944.82,
    y2: -2334.36,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1952.58,
    y1: -2343.18,
    x2: 1952.58,
    y2: -2344.51,
    gradientTransform: "translate(2348.21 1986.51) rotate(-90)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1952.52,
    y1: 1839.24,
    x2: 1952.52,
    y2: 1837.86,
    gradientTransform: "matrix(0, -1, -1, 0, 1850.1, 1986.48)",
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WATER-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left_Frame",
    "data-name": "Left Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base",
    className: "cls-1",
    d: "M0,46.25V53a.45.45,0,0,0,.14.33L15.26,67.57a.44.44,0,0,0,.75-.32v-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD",
    "data-name": "Right SD",
    className: "cls-2",
    d: "M16,67a1.25,1.25,0,0,1,0,.5,1.42,1.42,0,0,1-.19.18l-1-2.32V46.25H16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL",
    "data-name": "Top HL",
    className: "cls-3",
    d: "M14.81,65.31,1.35,52.26,0,53s0,.21.07.26c.31.27.65.61.65.61L14.68,67a4.25,4.25,0,0,0,.66.6.39.39,0,0,0,.45,0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL",
    "data-name": "Left HL",
    className: "cls-4",
    points: "1.35 52.26 0 52.97 0 46.25 1.35 46.25 1.35 52.26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-2",
    "data-name": "Base",
    className: "cls-5",
    points: "2.52 46.25 2.54 51.23 13.41 61.32 13.41 46.25 2.52 46.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD",
    "data-name": "Left SD",
    className: "cls-6",
    points: "3.71 46.25 3.71 50.63 2.54 51.23 2.52 46.25 3.71 46.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD",
    "data-name": "Top SD",
    className: "cls-7",
    points: "13.41 61.32 2.53 51.23 3.71 50.63 12.23 58.67 13.41 61.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-2",
    "data-name": "Right SD",
    className: "cls-8",
    points: "12.23 46.25 12.23 58.67 13.41 61.32 13.41 46.25 12.27 46.25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-3",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "12.23 46.25 12.23 58.67 3.72 50.63 3.71 46.25 12.23 46.25"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom",
    className: "cls-10",
    points: "10.89 55.57 10.89 46.25 12.23 46.25 12.23 58.67 10.89 55.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top",
    className: "cls-11",
    points: "5.05 46.25 5.05 49.84 3.71 50.63 3.71 46.25 5.05 46.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "12.23 58.67 3.71 50.63 5.05 49.84 10.89 55.57 12.23 58.67"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "14.81 65.31 13.41 61.27 13.41 46.26 14.81 46.25 14.81 65.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Right_Frame",
    "data-name": "Right Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame-2",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base-4",
    "data-name": "Base",
    className: "cls-14",
    d: "M0,21.44V14.72a.43.43,0,0,1,.14-.32L15.26.12A.45.45,0,0,1,16,.45v21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD-3",
    "data-name": "Right SD",
    className: "cls-15",
    d: "M16,.74a1.16,1.16,0,0,0,0-.49,1,1,0,0,0-.19-.18l-1,2.32V21.44H16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL-2",
    "data-name": "Top HL",
    className: "cls-16",
    d: "M14.81,2.39,1.34,15.44,0,14.72s0-.2.07-.26c.31-.27.65-.61.65-.61L14.68.67a4.25,4.25,0,0,1,.66-.6.39.39,0,0,1,.45,0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL-2",
    "data-name": "Left HL",
    className: "cls-17",
    points: "1.34 15.44 0 14.72 0 21.44 1.34 21.44 1.34 15.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame-2",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-5",
    "data-name": "Base",
    className: "cls-18",
    points: "2.52 21.44 2.54 16.47 13.41 6.37 13.41 21.44 2.52 21.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD-2",
    "data-name": "Left SD",
    className: "cls-19",
    points: "2.52 21.44 2.54 16.47 3.74 17.07 3.74 21.44 2.52 21.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD-2",
    "data-name": "Top SD",
    className: "cls-20",
    points: "13.41 6.37 2.53 16.47 3.73 17.07 12.26 9.02 13.41 6.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-4",
    "data-name": "Right SD",
    className: "cls-21",
    points: "12.26 21.44 12.26 9.02 13.41 6.37 13.41 21.44 12.27 21.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-2",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-6",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "12.26 21.44 12.26 9.02 3.75 17.07 3.74 21.44 12.26 21.44"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom-2",
    "data-name": "Bottom",
    className: "cls-22",
    points: "10.9 12.35 10.88 21.44 12.26 21.44 12.26 9.02 10.9 12.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top-2",
    "data-name": "Top",
    className: "cls-23",
    points: "5.08 21.44 5.08 17.86 3.74 17.07 3.74 21.44 5.08 21.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "12.26 9.02 3.74 17.07 5.08 17.86 10.9 12.35 12.26 9.02"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "14.81 2.4 13.41 6.43 13.41 21.43 14.81 21.44 14.81 2.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Center_Bars",
    "data-name": "Center Bars"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    y: 21.27,
    width: 16.01,
    height: 25.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 1.35,
    y: 21.27,
    width: 1.18,
    height: 25.34
  }), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Bars",
    "data-name": "Inner Bars"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M13.41,46.61V21.27m-10.89,0V46.62M13.41,21.27H12.26l0,17.46v7.89h1.18M3.74,21.27H2.52V46.62H3.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-5",
    "data-name": "Right SD",
    className: "cls-29",
    points: "13.41 21.27 13.41 46.62 12.23 46.62 12.26 21.27 13.41 21.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-3",
    "data-name": "Left SD",
    className: "cls-30",
    points: "3.74 21.27 3.71 46.62 2.52 46.62 2.52 21.27 3.74 21.27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Left_HL-3",
    "data-name": "Left HL",
    className: "cls-31",
    y: 21.27,
    width: 1.34,
    height: 25.33
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "14.81 46.61 13.41 46.62 13.41 21.27 14.81 21.27 14.81 46.61"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-3",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-7",
    "data-name": "Base",
    className: "cls-9",
    points: "12.26 21.27 3.74 21.27 3.71 46.62 12.23 46.62 12.26 21.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-4",
    "data-name": "Left SD",
    className: "cls-33",
    points: "5.05 21.27 5.05 46.62 3.71 46.62 3.74 21.27 5.05 21.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-6",
    "data-name": "Right SD",
    className: "cls-34",
    points: "10.88 21.27 10.88 46.62 12.23 46.62 12.26 21.27 10.88 21.27"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedVerticleStrip);
export default __webpack_public_path__ + "static/media/redVerticleStrip.eadb550ecb576dfaf4536b43586ba0b0.svg";
export { ForwardRef as ReactComponent };